var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ps",style:(_vm.vars)},[_c('main',{class:['ps-main', { narrow: _vm.narrow, wide: _vm.wide }]},[_vm._t("default")],2),(_vm.$slots.footer)?_c('footer',{staticClass:"ps-foot"},[_vm._t("footer")],2):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }